var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bindCar"},[_c('div',{staticClass:"car_num_holder"}),_vm._v(" "),_c('carNum-input',{on:{"getcarNumParent":_vm.getCarNum}}),_vm._v(" "),_c('van-button',{staticClass:"bt_qurey",attrs:{"color":"#f47b20"},on:{"click":_vm.bindCar}},[_vm._v("确认绑定")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e41169","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/bind/bindCar.vue
// module id = null
// module chunks = 